import { render, staticRenderFns } from "./ShowCommandDetail.vue?vue&type=template&id=4b684298&scoped=true"
import script from "./ShowCommandDetail.vue?vue&type=script&lang=js"
export * from "./ShowCommandDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b684298",
  null
  
)

export default component.exports